export const FIRST_NAME_MAX_LENGTH = 30;
export const LAST_NAME_MAX_LENGTH = 30;
export const EMAIL_MAX_LENGTH = 255;
export const INSURANCE_AND_BILLING_NOTES_MAX_LENGTH = 4000;
